import SiteData from "app/content/_site-globals.json";

export const useNavData = () => SiteData || {};
